<template>
  <ModalDialog
    ref="dialog"
    title="Edit Production Details"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-tools"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="stageForm" :labelColumnSize="3">
      <Spinner v-if="loading" />
      <template v-if="!loading">
        <FormRow label="Stock Categories">
          <FormMultiSelect v-show="!hasStockPriceGroupsSelected" v-model="stageData.stockCategories" field="stockCategories" :options="stockCategoryListLookup" />
          <FormStaticLabel v-if="hasStockPriceGroupsSelected">Price Groups Selected</FormStaticLabel>
        </FormRow>
        <FormHorizontalRule />
        <FormRow label="Price Groups">
          <FormMultiSelect v-show="!hasStockCategoriesSelected" v-model="stageData.stockPriceGroups" field="stockPriceGroups" :options="stockPriceGroupListLookup" />
          <FormStaticLabel v-if="hasStockCategoriesSelected">Stock Categories Selected</FormStaticLabel>
        </FormRow>
      </template>
      <p class="text-danger" v-if="loadingError">{{loadingError}}</p>

      <div class="row mt-4">
        <div class="col-12">
          <p><strong>Note:</strong> Only one method of linking is available. Both stock categories and price groups cannot be entered</p>
        </div>
      </div>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import { InventoryStockTypes } from '@/store/types'

export default {
  name: 'ProductionStageLinkDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    productionStageId: Number
  },
  data() {
    return {
      stageData: {
        stockPriceGroups: [],
        stockCategories: [],
      },
      stageForm: {},
      stockCategoryListLookup: [],
      stockPriceGroupListLookup: [],
      loadingError: '',
      loading: false,
      submitting: false
    }
  },
  created() {
  },
  mounted() {
    this.requestData()
  },
  computed: {
    hasStockPriceGroupsSelected() {
      return this.stageData.stockPriceGroups.length > 0
    },
    hasStockCategoriesSelected() {
      return this.stageData.stockCategories.length > 0
    }
  },
  methods: {
    show(productionStage) {
      // Reset form
      this.stageData = {
        stockCategories: [],
        stockPriceGroups: []
      }
      this.stageForm = {}
      this.submitting = false

      if(productionStage != null) {
        this.stageData = _.cloneDeep(productionStage)
        this.stageData.stockCategories = productionStage.stockCategories.map(stockCategory => stockCategory.id)
        this.stageData.stockPriceGroups = productionStage.stockPriceGroups.map(priceGroup => priceGroup.id)
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = {
        linkStockCategories: this.stageData.stockCategories,
        linkStockPriceGroups: this.stageData.stockPriceGroups
      }

      this.$apiService.productionService.updateProductionStage(this.stageData.id, updateData)
      .then(response => {
        this.submitting = false
        this.modalClosed(response.data.id)
        this.hide()
      })
      .catch(err => {
        this.submitting = false
        this.$data.stageForm = this.processFormResponse(err)
      })
    },

    requestData() {
      this.loading = true
      this.loadingError = ''

      // Load category & price group lists
      Promise.all([
        this.$apiService.inventoryService.getStockCategoryList(),
        this.$apiService.pricingService.getStockPriceGroupList()
      ])
      .then(results => {
        this.stockCategoryListLookup = results[0].data
        .filter(stockCategory => {
          return stockCategory.isActive && (stockCategory.stockType == InventoryStockTypes.glass || InventoryStockTypes.glassService)
        })
        .map(stockCategory => {
          return {
            value: stockCategory.id,
            name: stockCategory.name
          }
        })
        this.stockPriceGroupListLookup = results[1].data
        .filter(stockPriceGroup => {
          return stockPriceGroup.isActive && !stockPriceGroup.isStockLinked
        })
        .map(stockPriceGroup => {
          return {
            value: stockPriceGroup.id,
            name: stockPriceGroup.name
          }
        })
      })
      .catch(err => {
        this.loadingError = 'Error accessing data. Please check your internet connection and try again'
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>